import { render, staticRenderFns } from "./QuestionTemplateCard.vue?vue&type=template&id=8bb585ca&scoped=true&"
import script from "./QuestionTemplateCard.vue?vue&type=script&lang=js&"
export * from "./QuestionTemplateCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tailwind.min.css?vue&type=style&index=0&id=8bb585ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb585ca",
  null
  
)

export default component.exports